<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="ra_wrapper">
  <div class="alert alert-danger alert-dismissible fade show">
    <h4 class="alert-heading"><i class="fa fa-warning"></i> Access Denied!</h4>
    <p>Oops! You do not have access to this page. Only authorized user have access to this page!</p>
    <hr>
    <p class="mb-0">Click <i _ngcontent-c2="" class="fa fa-home fa-2x" tooltipposition="top"
        ng-reflect-tooltip-position="top" ng-reflect-text="HOME"></i> and navigate to dashboard page.</p>
  </div>
</div>